import styles from "../../../styles/alumniheader.module.css";
import Intro from "../components/Intro";
import Events from "../components/EventSection";
import Mission from "../components/Mission";
import Achievement from "../components/Achievement";
import Projects from "../components/Projects";
import Gallery from "../components/Gallery";
import Footer from "../components/Footer";
import Calender from "../components/Calendar";
const Home = () => {
    document.title = "IGSOSA - Home";
    return ( 
 <div className={styles.homewrapper}>
      <header className={styles.alumni}>
        <div className={styles['header-overlay']}>
                  <Intro></Intro>
        </div>
      </header>

      <div className={styles.projects}>
        <Events></Events>
      </div>

      <Projects isHomepage={true} maxItems={3}></Projects>
      <Gallery isHomepage={true} maxRecords={3}></Gallery>
      <div id="igsosa-calendar-section">
        <Calender></Calender>
      </div>
        <Mission></Mission>
        <Achievement></Achievement>
    <Footer></Footer>
    </div>


     );
}
 
export default Home;
